<template>
  <div class="auth-user-page">
    <base-sign-page
      title-text="用户"
      :note-text="noteText"
      :column-list="columnList"
      :data-list="dataList"
      @countDataChange="countDataChange"
      :count-fun="countFun"
      :tableActionsWidth="160"
      :show-search="true"
      :loading="loading"
      :title-menus="titleMenus"
      @clickTitleMenu="clickTitleMenu"
      :table-actions-fixed="true"
      @tableAction="tableAction"
      :table-actions="tableActions"
      :need-pagination="true">
    </base-sign-page>
    <fm-modal
      :mask-closable="false"
      :value="openDialog"
      width="800"
      v-if="openDialog"
      theme="mh-withe"
      @cancel="openDialog = false">
      <user-form @close="openDialog = false" :org-tree="orgTree" :roleList="sysRoles" @reload="loadData(true)" :user="chooseData" />
    </fm-modal>
    <sort-modal ref="sortmodal" :dataList="dataList" @change="sortNumChange"></sort-modal>
  </div>
</template>

<script>
import BaseSignPage from '@/components/base/BaseSignPage'
import UserForm from './user/form.vue'
import sortModal from './user/sort'

import {
  userRequest as request
} from '@/api'

import {
  delUserDeal
} from '@/sys'

export default {
  components: {
    BaseSignPage, UserForm, sortModal
  },
  watch: {},
  computed: {
    tableActions: {
      get () {
        return [{
          label: '删除',
          key: 'del'
        },
        {
          label: '修改',
          key: 'edit'
        },
        {
          label: '重置密码',
          key: 'reset_pwd'
        }].filter(({key}) => this.$authFunsProxy[key])
      }
    },
    titleMenus: {
      get () {
        return [{
          key: 'sort',
          label: '默认排序设置'
        },
        {
          key: 'add',
          label: '新增'
        }].filter(({key}) => this.$authFunsProxy[key])
      }
    },
    userStatusList () {
      return this.$store.getters.userStatusList
    },
    sysRoles: {
      get () {
        return this.$store.getters.roleList.filter(v => v.data.roleType === 'role')
      }
    },
    orgTree () {
      return this.$store.getters.orgTree
    },
    columnList: {
      get () {
        return [{
          field: 'name',
          sort: true,
          title: '姓名'
        },
        // {
        //   field: 'nickname',
        //   sort: true,
        //   title: '昵称'
        // },
        {
          field: 'account',
          sort: true,
          title: '账号'
        },
        {
          field: 'phone',
          sort: true,
          title: '电话'
        },
        {
          field: 'idNo',
          sort: true,
          title: '身份证号'
        },
        {
          field: 'orgRoleLabels',
          sort: true,
          title: '组织架构'
        },
        {
          field: 'roleNames',
          sort: true,
          title: '角色权限'
        },
        {
          field: 'sortNum',
          sort: true,
          title: '排序值'
        },
        {
          field: 'statusText',
          sort: true,
          title: '状态',
          filters: this.userStatusList.map(v => {
            return {
              label: v.label,
              value: v.label
            }
          })
        }]
      }
    }
  },
  async created () {
    if (this.$authFunsProxy.edit || this.$authFunsProxy.add) {
      this.$store.dispatch('loadOrgTree')
      this.$store.dispatch('loadRoleList')
    }
    this.loadData()
  },
  methods: {
    sortNumChange (id, sortNum) {
      let data = this.dataList.find(v => v.id === id)
      data.sortNum = sortNum
      let list1 = this.dataList.filter(v => v.sortNum !== null)
      let List2 = this.dataList.filter(v => v.sortNum === null)
      list1.sort((a, b) => Number(a.sortNum) - Number(b.sortNum))
      this.dataList = list1.concat(List2)
    },
    tableAction (data) {
      this.chooseData = data.data
      if (data.action === 'edit') {
        this.openDialog = true
      } else if (data.action === 'del') {
        this.delData()
      } else if (data.action === 'reset_pwd') {
        this.resetPassword()
      }
    },
    async resetPassword () {
      const result = await this.$dialog.confirm({title: '系统提示', content: '确定重置用户 ' + this.chooseData.name + ' 的密码吗?'})
      if (result) {
        request.resetPassword(this.chooseData.id).then(() => {
          this.$notice.success({
            title: '系统提示',
            desc: '密码重置成功'
          })
        })
      }
    },
    async delData () {
      this.loading = true
      let otherDel = await delUserDeal(this, this.chooseData.id)
      if (otherDel) {
        if (otherDel === 'done') {
          this.loadData()
          this.$store.dispatch('loadUserList', true)
          this.$notice.info({
            title: '系统提示',
            desc: '用户已删除'
          })
          this.loading = false
        } else {
          this.loading = false
        }
      } else {
        const result = await this.$dialog.confirm({title: '系统提示', content: '确定删除用户 ' + this.chooseData.name + ' 吗?'})
        if (result) {
          await request.del(this.chooseData.id)
          this.$notice.info({
            title: '系统提示',
            desc: '用户已删除'
          })
          this.loading = false
          this.loadData()
          this.$store.dispatch('loadUserList', true)
        } else {
          this.loading = false
        }
      }
    },
    countFun (data) {
      return data.length
    },
    countDataChange (data) {
      this.noteText = '总数:' + data
    },
    clickTitleMenu (parm) {
      if (parm === 'add') {
        this.chooseData = {}
        this.openDialog = true
      } else if (parm === 'sort') {
        this.$refs.sortmodal.modal = true
      }
    },
    async loadData (reload) {
      if (!this.$authFunsProxy.get) {
        return
      }
      this.loading = true
      let parm = {
        needRoleInfo: 1
      }
      let data = await request.get(parm)
      data.forEach(v => {
        v.roleNames = v.orgRoles.filter(v1 => !v1.orgId && v1.roleId).map(v2 => v2.roleName).join(',')
        v.orgRoleLabels = v.orgRoles.filter(v1 => v1.orgId).map(v2 => v2.orgName + '/' + (v2.roleName || '无职务')).join(',')
        v.statusText = (this.userStatusList.find(v1 => v1.key === v.status) || {label: v.status}).label
      })
      this.loading = false
      this.dataList = data
      if (reload) {
        this.$store.dispatch('loadUserList', true)
      }
    }
  },
  data () {
    return {
      openDialog: false,
      dataList: [],
      noteText: '',
      loading: true,
      chooseData: {}
    }
  }
}
</script>
